"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SlykMask = SlykMask;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Module dependencies.
 */

/**
 * Constants.
 */
var width = 41.9;
var height = 43.8;
var scaleX = 1 / width;
var scaleY = 1 / height;
/**
 * Export `SlykMask` component.
 */

function SlykMask() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    "aria-hidden": true,
    height: 0,
    viewBox: "0 0 ".concat(width, " ").concat(height),
    width: 0
  }, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
    clipPathUnits: 'objectBoundingBox',
    id: 'slyk-mask',
    transform: "scale(".concat(scaleX, " ").concat(scaleY, ")")
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: 'M38.9 6.8C32.6-2.3 9.2-2.3 3 6.8c-2 2.9-3 7.9-3 15.1s1 12.1 3 15c6 8.8 29.7 9.4 35.8.4 2-2.9 3-8.1 3-15.4.1-7.1-.9-12.2-2.9-15.1z'
  }))));
}